/* Collection pages (sections/main-collection.liquid): filter chips in place with the state in the address
   (?filter=skims, ?type=robot, ?price=0-150000; type comes from the card's data-kind) and Sort. ?robot=<handle>
   (the Shop menu's robot chips) keeps only cards whose data-fits includes that robot, with a "Parts for ..." note. The Compare tray is shared by every
   page: assets/compare-tray.js. */
if (!customElements.get('collection-filters')) {
  class CollectionFilters extends HTMLElement {
    connectedCallback() {
      this.cards = [...this.querySelectorAll('[data-card]')];
      const params = new URLSearchParams(location.search);
      this.state = { filter: params.get('filter') || '', type: params.get('type') || '', price: params.get('price') || '' };
      this.robot = params.get('robot') || '';
      const note = this.querySelector('[data-robot-note]');
      const label = this.querySelector(`[data-robot-label="${CSS.escape(this.robot)}"]`);
      if (note && this.robot && label) { note.querySelector('[data-robot-name]').textContent = label.textContent.trim(); note.hidden = false; }

      this.querySelectorAll(".coll-bar [data-filter], .coll-bar [data-type], .coll-bar [data-price]").forEach((chip) => {
        chip.addEventListener('click', () => {
          if (chip.hasAttribute('data-filter') && chip.dataset.filter === '') this.state = { filter: '', type: '', price: '' };
          else if (chip.hasAttribute('data-filter')) this.state.filter = this.state.filter === chip.dataset.filter ? '' : chip.dataset.filter;
          else if (chip.hasAttribute('data-type')) this.state.type = this.state.type === chip.dataset.type ? '' : chip.dataset.type;
          else this.state.price = this.state.price === chip.dataset.price ? '' : chip.dataset.price;
          this.saveUrl();
          this.render();
        });
      });

      const sort = this.querySelector('[data-sort]');
      if (sort) sort.addEventListener('change', () => {
        const url = new URL(location.href);
        if (sort.value) url.searchParams.set('sort_by', sort.value); else url.searchParams.delete('sort_by');
        location.href = url.toString();
      });

      this.render();
    }

    saveUrl() {
      const url = new URL(location.href);
      ['filter', 'type', 'price'].forEach((k) => { if (this.state[k]) url.searchParams.set(k, this.state[k]); else url.searchParams.delete(k); });
      history.replaceState(null, '', url);
    }

    matches(card) {
      const { filter, type, price } = this.state;
      if (this.robot && card.dataset.fits !== undefined && !card.dataset.fits.split(' ').includes(this.robot)) return false;
      if (this.robot && card.dataset.fits === undefined && card.dataset.kind === 'accessory') return false;
      if (filter && !card.dataset.features.split(' ').includes(filter)) return false;
      if (type && card.dataset.kind !== type) return false;
      if (price) {
        const [lo, hi] = price.split('-').map((n) => (n === '' ? Infinity : Number(n)));
        const p = Number(card.dataset.amount);
        if (p < lo || p >= hi) return false;
      }
      return true;
    }

    isAfterDivider(card) {
      const divider = this.querySelector('[data-divider]');
      return divider ? Boolean(divider.compareDocumentPosition(card) & Node.DOCUMENT_POSITION_FOLLOWING) : false;
    }

    render() {
      let shown = 0;
      this.cards.forEach((card) => {
        const ok = this.matches(card);
        card.classList.toggle('is-hidden', !ok);
        if (ok) shown += 1;
      });
      const active = Boolean(this.state.filter || this.state.type || this.state.price);
      const quiz = this.querySelector('[data-quiz]');
      if (quiz) quiz.hidden = active;
      const divider = this.querySelector('[data-divider]');
      if (divider) divider.hidden = Boolean(this.state.type) || !this.cards.some((c) => this.isAfterDivider(c) && !c.classList.contains('is-hidden'));
      this.querySelector('[data-empty]').hidden = shown > 0;

      this.querySelectorAll('[data-filter]').forEach((c) => c.classList.toggle('is-on', c.dataset.filter === '' ? !active : c.dataset.filter === this.state.filter));
      this.querySelectorAll('[data-type]').forEach((c) => c.classList.toggle('is-on', c.dataset.type === this.state.type));
      this.querySelectorAll(".coll-bar [data-price]").forEach((c) => c.classList.toggle("is-on", c.dataset.price === this.state.price));
      const count = this.querySelector('[data-count]');
      if (count) count.textContent = (shown === 1 ? count.dataset.one : count.dataset.other).replace('[n]', shown);
    }
  }
  customElements.define('collection-filters', CollectionFilters);
}
